import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const NAV = [
  { label: "首页", to: "/" },
  { label: "综艺名场面", to: "/category/zongyi" },
  { label: "影视热映", to: "/category/yingshi" },
  { label: "乐坛现场", to: "/category/yinyue" },
  { label: "圈内观察", to: "/category/guancha" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  });

  return (
    <header
      className={
        "sticky top-0 z-40 w-full transition-all duration-300 " +
        (scrolled
          ? "bg-background-50/95 shadow-sm shadow-background-200/40 backdrop-blur border-b border-background-200/70"
          : "bg-background-50/70 backdrop-blur border-b border-transparent")
      }
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8 lg:px-12">
        {/* logo = H1 */}
        <h1 className="shrink-0">
          <Link
            to="/"
            className="group flex items-center gap-2"
            aria-label="海角吃瓜首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg leading-none" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              海角<span className="text-primary-600">吃瓜</span>
            </span>
          </Link>
        </h1>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-900 md:flex">
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            今日瓜报更新中
          </span>
          <button
            type="button"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav
          className="border-t border-background-200/70 bg-background-50 px-4 py-4 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="grid gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-lg px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                {n.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}